import axios from 'axios';

/**
 * Configuração central da instância do Axios.
 * A baseURL é lida do arquivo .env.
 * O valor de REACT_APP_API_URL deve ser: http://192.168.1.141:5656/tecnochatws
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default api;
